export default function CTA() {
  return (
    <section className="section" id="contact">
      <div className="container">
        <div className="cta-card">
          <h2 className="cta-title">See it in action.</h2>
          <p className="cta-lede">
            We'll walk you through the admin dashboard, the parent portal, and
            how billing works for your school's specific fee structure. No
            commitment, no sales pitch.
          </p>
          <div className="cta-actions">
            <a href="mailto:hello@easyschoolpayments.com" className="btn btn-primary btn-large">
              hello@easyschoolpayments.com
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
